<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row style="align-items: center">
        <v-col>
          <h3>Grupos de Usuário</h3>
        </v-col>
        <v-col class="text-right">
          <v-btn @click="changeEditMode" v-permission="'grp'" color="blue-grey lighten-1" depressed dark>
            <v-icon>mdi-plus</v-icon> Adicionar
          </v-btn>
        </v-col>
        <v-col cols="2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Buscar"
            dense
            single-line
            hide-details
            outlined
            color="primary"
            v-model="search"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="pa-5 mb-5 elevation-hb">
      <v-data-table :headers="headers" :items="groups" :search="search" :loading="loading">
        <template v-slot:[`item.action`]="{ item }">
          <v-icon class="ma-1" @click="editGroup(item)" v-permission="'grp'">mdi-pencil</v-icon>
          <v-icon class="ma-1" @click="deleteGroup(item)" v-permission="'grp'">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" max-width="700px">
      <HubbleDialog icon="mdi-group" :title="formTitle">
        <template v-slot:body>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="group.idGrp"
                  label="ID do grupo"
                  :disabled="editing"
                  color="primary"
                  :rules="rules.name"
                  required
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field v-model="group.descGrp" label="Descrição do grupo" color="primary" required outlined></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field v-model="group.groupType" label="Tipo do Grupo" color="primary" required outlined></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:dialogButtons>
          <v-btn icon @click="dialog = false" small>
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </template>
        <template v-slot:actions>
          <v-btn color="amber darken-3" dark depressed @click="reset">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="teal darken-4" dark depressed v-show="!editing" @click="saveGroup">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
          <v-btn color="blue-grey darken-2" :disabled="!valid" dark depressed @click="saveEditedGroup" v-show="editing">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </template>
      </HubbleDialog>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import HubbleDialog from '@/components/HubbleDialog'

export default {
  name: 'Groups',
  components: { HubbleDialog },
  data: () => ({
    loading: false,
    dialog: false,
    valid: false,
    match: null,
    menu: false,
    search: '',
    editing: false,
    group: {},
    groups: [],
    headers: [
      { text: 'ID', value: 'idGrp' },
      { text: 'Grupo', value: 'descGrp' },
      { text: 'Ações', value: 'action', sortable: false },
    ],
    rules: {
      name: [
        (v) => !!v || 'ID é obrigatório!',
        (v) => (v && v.length <= 100) || 'ID não pode ter mais de 100 caracteres!',
        (v) => /^[a-z]+-*[a-z]*$/.test(v) || 'Apenas letras minúsculas e "-" são permitidos no ID',
      ],
    },
  }),
  computed: {
    formTitle() {
      return this.editing == false ? 'Adicionar Grupo' : 'Editar Grupo'
    },
  },
  methods: {
    loadGroups() {
      this.loading = true
      const url = `${baseApiUrl}/grp`
      axios
        .get(url)
        .then((res) => {
          this.groups = res.data
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    validateField() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    changeEditMode() {
      this.group = {}
      this.editing = false
      this.dialog = true
    },
    saveGroup() {
      const url = `${baseApiUrl}/grp`
      axios
        .post(url, this.group)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadGroups()
          this.reset()
          this.dialog = false
        })
        .catch(showError)
    },
    saveEditedGroup() {
      const url = `${baseApiUrl}/grp/${this.group.idGrp}`
      axios
        .put(url, this.group)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadGroups()
          this.reset()
          this.editing = false
          this.dialog = false
        })
        .catch(showError)
    },
    editGroup(group) {
      this.editing = true
      this.group = Object.assign({}, group)
      this.dialog = true
    },
    deleteGroup(group) {
      const url = `${baseApiUrl}/grp/${group.idGrp}`
      if (confirm('Tem certeza que deseja desabilitar este grupo?')) {
        axios
          .delete(url)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadGroups()
          })
          .catch(showError)
      }
    },
  },
  mounted() {
    this.loadGroups()
  },
}
</script>
